import type { ApolloCache, TypedDocumentNode, Unmasked } from '@apollo/client';
import type {
  ModifierDetails,
  Reference,
  StoreObject,
} from '@apollo/client/cache';
import type { AsStoreObject } from '@apollo/client/utilities';

const addFragmentReference =
  <Data extends { id: string }, Fragment extends TypedDocumentNode<Data>>(
    cache: ApolloCache<unknown>,
    data: Unmasked<Data>,
    fragment: Fragment,
    fragmentName: string,
  ) =>
  <
    Refs extends readonly (
      | Reference
      | AsStoreObject<{ __typename?: string }>
    )[],
  >(
    refs: Refs,
    { readField }: ModifierDetails,
  ) => {
    if (refs.some((ref) => readField('id', ref as StoreObject) === data.id)) {
      return refs;
    }

    return [
      ...refs,
      cache.writeFragment({
        data,
        fragment,
        fragmentName,
      }),
    ];
  };

export default addFragmentReference;
